import { useState } from 'react';

export default function ContactForm() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    role: '',
    message: '',
  });
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const response = await fetch('https://nisharhardware.com/api/contactform', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        alert('Your message has been sent successfully!');
        setFormData({
          firstName: '',
          lastName: '',
          email: '',
          phone: '',
          role: '',
          message: '',
        });
      } else {
        alert('There was a problem sending your message. Please try again.');
      }
    } catch (err) {
      console.error('Error:', err);
      alert('An error occurred. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section className="bg-white py-16 px-4 md:px-20" id="contact">
      <h2 className="text-3xl font-bold mb-6 text-center">
        Feel free to reach us and get to know more about our range
      </h2>
      <form
        className="space-y-4 max-w-xl mx-auto"
        onSubmit={handleSubmit}
      >
        {/* First & Last Name */}
        <div className="flex flex-col md:flex-row gap-4">
          <input
            type="text"
            name="firstName"
            placeholder="First Name"
            required
            className="w-full border p-3 rounded"
            value={formData.firstName}
            onChange={handleChange}
          />
          <input
            type="text"
            name="lastName"
            placeholder="Last Name"
            required
            className="w-full border p-3 rounded"
            value={formData.lastName}
            onChange={handleChange}
          />
        </div>

        {/* Email & Contact Number */}
        <div className="flex flex-col md:flex-row gap-4">
          <input
            type="email"
            name="email"
            placeholder="Email Address"
            required
            className="w-full border p-3 rounded"
            value={formData.email}
            onChange={handleChange}
          />
          <input
            type="tel"
            name="phone"
            placeholder="Contact Number"
            required
            className="w-full border p-3 rounded"
            value={formData.phone}
            onChange={handleChange}
          />
        </div>

        {/* Your Role Dropdown */}
        <div>
          <select
            name="role"
            required
            className="w-full border p-3 rounded text-gray-500"
            value={formData.role}
            onChange={handleChange}
          >
            <option value="">Select Role...</option>
            <option value="Architect">Architect</option>
            <option value="Interior Designer">Interior Designer</option>
            <option value="Dealer">Dealer</option>
          </select>
        </div>

        {/* Message */}
        <textarea
          name="message"
          placeholder="Your Message"
          required
          className="w-full border p-3 rounded"
          rows={5}
          value={formData.message}
          onChange={handleChange}
        ></textarea>

        {/* Submit Button */}
        <button 
          type="submit" 
          disabled={isLoading}
          className={`px-6 py-3 rounded transition-all duration-300 ${
            isLoading 
              ? 'bg-gray-400 text-gray-200 cursor-not-allowed' 
              : 'bg-black text-white hover:bg-gray-800'
          }`}
        >
          {isLoading ? (
            <span className="flex items-center justify-center gap-2">
              <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              Sending...
            </span>
          ) : (
            'Submit'
          )}
        </button>
      </form>
    </section>
  );
}
